import React from 'react';
import { observer } from 'mobx-react';
import { useFormikContext } from 'formik';
import { makeStyles } from '@material-ui/core/styles';

import FormList from 'core/components/form-list';
import { useDisabledState } from 'common/disabled-context';
import {
  getLocationOptions,
  getEquipmentOptions,
  getRiskOptions,
  getSppOptions,
  getRpsOptions,
  getFarmPolicyMask
} from 'common/helpers/farm-helpers';
import { Locations } from './locations';
import { PolicyWideEndorsements } from './policy-wide-endorsements';
import { LiabilityCoverages } from './liability-coverages';
import { AddFarmInterestedPartyForm, FarmInterestedParty } from './additional-party';
import { AddMortgage, MortgageItem } from '../mortgage-details';

const useStyles = makeStyles((theme) => ({
  innerContainer: {
    padding: theme.spacing(8),
    backgroundColor: theme.colors.card_background_primary_editable,
    borderRadius: theme.sizes.roundCorners
  }
}));

function FarmOffer() {
  const { values } = useFormikContext();
  const { disabled } = useDisabledState();
  const classes = useStyles();

  const locationOptions = getLocationOptions(values.farmLocations);
  const equipmentOptions = getEquipmentOptions(values.farmLocations);
  const riskOptions = getRiskOptions(values.farmLocations, values.policyType, values.state);
  const sppOptions = getSppOptions(values.farmLocations);
  const rpsOptions = getRpsOptions(values.farmLocations);

  const includeFarmLiability = values.includeFarmLiability;
  const liabilityType = values.farmLiabilityCoverage?.type;

  // Title for the interested-party list comes from the policy-type mask so Forreston Rental (Y)
  // and Home (Z) show "Additional Insured/Interest". (#31367)
  const farmPolicyMask = getFarmPolicyMask(values.policyType, values.state);
  const interestedPartyTitle = farmPolicyMask?.interestedPartyLabel || 'Farm Additional Interests/Insureds';

  return (
    <>
      <Locations />
      <LiabilityCoverages />
      <PolicyWideEndorsements />
      <FormList
        key={`parties-${disabled}`}
        id="farmInterestedParties"
        item={FarmInterestedParty}
        addForm={AddFarmInterestedPartyForm}
        title={interestedPartyTitle}
        singular="Interest/Insured"
        plural="Interests/Insureds"
        disabled={disabled}
        locationOptions={locationOptions}
        equipmentOptions={equipmentOptions}
        riskOptions={riskOptions}
        sppOptions={sppOptions}
        rpsOptions={rpsOptions}
        includeFarmLiability={includeFarmLiability}
        liabilityType={liabilityType}
        existingParties={values.farmInterestedParties || []}
      />
      <FormList
        classes={classes}
        id="farm.mortgageDetails"
        item={MortgageItem}
        addForm={AddMortgage}
        title="Mortgage lender information"
        singular="Mortgage"
        plural="Mortgages"
        disabled={disabled}
      />
    </>
  );
}
export default observer(FarmOffer);
